import { accountServiceModule } from '../../../shared/app/services/account-service/account-service';
import { appConfig } from '../../../shared/app/constants/app-config';
import { embedded } from './embedded';

export const LOGOUT_EJECT_EXCLUDES = [
  'Assessment',
  'Team',
  'Customer',
  'ChallengeItem',
  'Challenge',
];

export const accountServiceConfigModule = angular
  .module('Q.config.account-service', [accountServiceModule])

  .config(function (accountServiceProvider) {
    accountServiceProvider.setModelName('Candidate');
    accountServiceProvider.setLogoutEjectExcludes(LOGOUT_EJECT_EXCLUDES);
    accountServiceProvider.setIncludes(['team_ids']);
    accountServiceProvider.setAccountUrl(appConfig.assessRoute + '/');
    // Assess app exclusively relies on assessment_result_auth#authorize API to handle user authentication
    // as part of its init code, so no need to lookup existing session.
    accountServiceProvider.setSkipLookup(true);

    // check to see if embedded, because we're in temporary mode then
    if (embedded) {
      accountServiceProvider.setTemporary(true); // embeds do not preserve login info
    }
  });
